import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { registerViewsKeys } from '../registerViewKeys'
import { RequestTypes } from '../requestTypes'
import { RegisterTemplate } from '@core/entities/register/RegisterTemplate'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useCreateRegisterView = (
  options?: UseMutationOptions<
    RegisterTemplate,
    RequestErrorType,
    RequestTypes['createRegisterView']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...registerViewsKeys.createRegisterView,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: registerViewsKeys._def })
    },
    ...options,
  })
}
